import { Component, Inject, Input } from '@angular/core';
import { FeedbackService } from 'src/app/shared/services/feedback.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/model/environment.model';

@Component({
  selector: 'app-feedback-table-wrapper',
  templateUrl: './feedback-table-wrapper.component.html',
  styleUrl: './feedback-table-wrapper.component.scss',
  standalone: false
})
export class FeedbackTableWrapperComponent {
  
  constructor(
    public feedbackService: FeedbackService,
    private utilityService: UtilityService,
    @Inject(ENVIRONMENT_CONFIG) public environment: EnvironmentConfiguration
  ) {}

  @Input() data: any;
  tableId: string;
  public userRole: any;
  public isEnvironment : string | null = this.environment.name;
  showRedirectMessage : boolean = false;
  
  ngOnInit() {
    if(this.isEnvironment=='test'){
      this.showRedirectMessage = true;
    }
    this.userRole = sessionStorage.getItem('RoleId');
    this.tableId = this.data?.tableId;
    this.utilityService.setActiveTab(this.data.tabNo, 'feedbackActiveIndex');
  }

  redirectToProd(): void {
    window.open("https://hrtconnect.apps.gea.com/#/feedback", '_blank')
  }
}
